import { Link } from "react-router-dom";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";
import { POStatusBadge } from "@/lib/poStatus";

const num = (n) => Math.round(n).toLocaleString();

export function OnOrderDialog({ ooKey, ooName, onOrder, onClose }) {
  const entry = ooKey ? onOrder[ooKey] : null;
  const orders = entry?.orders || [];
  return (
    <Dialog open={!!ooKey} onOpenChange={(o) => { if (!o) onClose(); }}>
      <DialogContent className="rounded-sm sm:max-w-2xl" data-testid="on-order-dialog">
        <DialogHeader>
          <DialogTitle className="font-heading tracking-tight">On Order</DialogTitle>
          <DialogDescription>{ooName} — ordered from suppliers, not yet received.</DialogDescription>
        </DialogHeader>
        {orders.length === 0 ? (
          <p className="py-6 text-center text-sm text-slate-400">No open supplier orders.</p>
        ) : (
          <table className="w-full border-collapse text-sm" data-testid="on-order-table">
            <thead>
              <tr className="text-[10px] uppercase tracking-[0.08em] text-slate-500">
                <th className="border-b border-slate-200 px-2 py-2 text-left font-semibold">PO</th>
                <th className="border-b border-slate-200 px-2 py-2 text-left font-semibold">Supplier</th>
                <th className="border-b border-slate-200 px-2 py-2 text-left font-semibold">Status</th>
                <th className="border-b border-slate-200 px-2 py-2 text-left font-semibold">ETA</th>
                <th className="border-b border-slate-200 px-2 py-2 text-right font-semibold">Received</th>
                <th className="border-b border-slate-200 px-2 py-2 text-right font-semibold">Remaining</th>
              </tr>
            </thead>
            <tbody>
              {orders.map((o, i) => (
                <tr key={`${o.po_id}-${i}`} className="text-slate-700" data-testid={`on-order-row-${i}`}>
                  <td className="border-b border-slate-100 px-2 py-2 font-semibold text-slate-900 whitespace-nowrap">
                    <Link to="/purchase-orders" className="text-[#002FA7] hover:underline" data-testid={`on-order-po-link-${i}`}>{o.po_number}</Link>
                  </td>
                  <td className="border-b border-slate-100 px-2 py-2">{o.supplier_name || "—"}</td>
                  <td className="border-b border-slate-100 px-2 py-2"><POStatusBadge status={o.status} partial={o.received > 0} /></td>
                  <td className="border-b border-slate-100 px-2 py-2 whitespace-nowrap">{o.eta || "—"}</td>
                  <td className="border-b border-slate-100 px-2 py-2 text-right tabular-nums text-slate-500">{num(o.received)} / {num(o.quantity)}</td>
                  <td className="border-b border-slate-100 px-2 py-2 text-right font-medium tabular-nums">{num(o.remaining)}</td>
                </tr>
              ))}
              <tr className="text-slate-900">
                <td className="px-2 py-2 text-xs font-semibold uppercase tracking-wide" colSpan={5}>Total on order</td>
                <td className="px-2 py-2 text-right font-bold tabular-nums" data-testid="on-order-total">{num(entry?.on_order || 0)}</td>
              </tr>
            </tbody>
          </table>
        )}
        <p className="text-right text-xs">
          <Link to="/purchase-orders" className="font-semibold text-[#002FA7] hover:underline" data-testid="on-order-open-page">Open Purchase Orders →</Link>
        </p>
      </DialogContent>
    </Dialog>
  );
}
